import script from "./OrganismsTooltipChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganismsTooltipChart.vue?vue&type=script&setup=true&lang=ts"

import "./OrganismsTooltipChart.vue?vue&type=style&index=0&id=75565969&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75565969"]])

export default __exports__